module.exports = __webpack_public_path__ + "static/media/chevron-down.a0b94e73.svg";